import { isEmailValid } from "utilz/helpers";
import { validateEmailLocalPart } from "../../helpers";
import { NewUser } from "../../../types";
import { SetStateAction } from "react";

export const validateNewUserInputAndAddToList = ({
  fullName,
  setFullName,
  email,
  setEmail,
  newUsersInDrawer,
  setNewUsersInDrawer,
  setAddNewUserError,
  isUserPrivileged,
}: {
  fullName: string;
  setFullName: (value: SetStateAction<string>) => void;
  email: string;
  setEmail: (value: SetStateAction<string>) => void;
  newUsersInDrawer: NewUser[];
  setNewUsersInDrawer: any;
  setAddNewUserError: any;
  isUserPrivileged: boolean;
}) => {
  const fullNameValue = fullName.trim();
  const emailValue = email.trim();
  if (fullNameValue && emailValue) {
    if (!isEmailValid(emailValue)) {
      setAddNewUserError(
        "Please enter a valid email address format (example@domain.com)",
      );
      return false;
    }
    if (emailValue.length > 75) {
      setAddNewUserError("Email cannot exceed 75 characters");
      return false;
    }
    const localPart = emailValue.split("@")[0];
    const localPartValidation = validateEmailLocalPart(localPart);
    if (!localPartValidation.isValid) {
      setAddNewUserError(localPartValidation.error || "Invalid email username");
      return false;
    }
    const isEmailAlreadyExists = newUsersInDrawer.some(
      (user: any) => user.email === emailValue,
    );
    if (isEmailAlreadyExists) {
      setAddNewUserError("Email already exists");
      return false;
    }
    setNewUsersInDrawer((prev: NewUser[]) => [
      {
        full_name: fullNameValue,
        email: emailValue,
        IsPrivileged: isUserPrivileged,
      },
      ...prev,
    ]);
    setFullName("");
    setEmail("");
    setAddNewUserError("");
    return true;
  } else {
    setAddNewUserError("");
    return true;
  }
};
